import {Nullable} from "../../models/common/Nullable";
import {
    errorFetchingRequestState,
    getInitialRequestState,
    RequestState,
    startFetchingRequestState,
    successFetchingRequestState
} from "../../models/common/RequestState";
import {ProjectReport} from "../../models/reporting/ProjectReport";
import {
    FETCH_PROJECT_REPORT,
    FETCH_PROJECT_REPORT_ERROR,
    FETCH_PROJECT_REPORT_SUCCESS,
    ProjectReportActionTypes
} from "../../actions/reporting/ProjectReportActions";

export interface ProjectReportState {
    totalEntries: number
    entries: Nullable< ProjectReport[] >
    request: RequestState
}

const initialState: ProjectReportState = {
    totalEntries: 0,
    entries: null,
    request: getInitialRequestState()
}

export function ProjectReportReducer(
    state: ProjectReportState = initialState,
    action: ProjectReportActionTypes
) {

    switch( action.type ) {
        case FETCH_PROJECT_REPORT:
            return {
                ...state,
                totalEntries: 0,
                entries: null,
                request: startFetchingRequestState()
            };
        case FETCH_PROJECT_REPORT_SUCCESS:
            return {
                ...action.reports,
                request: successFetchingRequestState()
            };
        case FETCH_PROJECT_REPORT_ERROR:
            return {
                ...state,
                request: errorFetchingRequestState( action.error )
            };
        default:
            return state;
    }

}